



































































































































































































































































import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import Footer from '@/components/Footer.vue'

@Component({
  components: {
    Footer
  }
})
export default class FirstView extends Vue {
  public pushQuestion () {
    this.$router.push('/question')
  }

  public openWindow (url: string) {
    window.open(url, '_blank', 'width=1024,height=768,scrollbars=yes,resizable=yes')
  }

  created () {
    window.scrollTo({
      top: 0
    })
  }
}
